export const emptyGuid = "00000000-0000-0000-0000-000000000000";
export const notFoundRouteName = "NotFound";
export const getIsUserRegisteredForGiveawayCookieKey = (giveawaySlug: string) =>
  `isUserRegisteredForGiveaway_${giveawaySlug}`;
export const NITRO_CLOUDFLARE_KV_BINDING_NAME = "STORAGE";
export const SEARCH_INPUT_ID = "global-search-input";
